import React from "react";
import SectionLoadingError from '../common/SectionLoadingError';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";

class RxError extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Rx.RxError.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    tryAgain = (e) => {
        e.preventDefault();
        if (this.props.resetStep) {
            this.props.resetStep(e);
        }
    }

    render() {
        const { userName, name, apiMessage, messageIcon, sectionErrorClass, hasPharmacyLogin } = this.props;        
        let userNameString = userName + (name ? " " + name : "");

        return (
            <div className="row service-error-container">
                <div className="col-12">
                    <SectionLoadingError message={apiMessage ? apiMessage : "We're sorry, " + userNameString + " didn't go through."} messageIcon={messageIcon} sectionErrorClass={sectionErrorClass} />
                    {hasPharmacyLogin &&
                        <a href="#" onClick={this.tryAgain}>TRY AGAIN</a>
                    }
                </div>
            </div>
        );
    }
}

export default RxError;